import React, { useCallback } from 'react';
import { Happy, Sad } from './smiley';
import { Figure } from './figure';
import { Form } from './form';
import { toggleIsPositive } from './feedbacks-actions';
import { Details } from './details';

export const _LeaveFeedbackItem = ({
    alias,
    className = '',
    comment = '',
    dispatch,
    errorMessageTranslationKeys,
    imageUrl,
    isItemNotReceived,
    memberUrl,
    title,
    transactionDate,
    transactionId,
    url,
    isPositive,
    isNegative,
    ratingSettings,
    ratings,
    state,
    unpaidItemUrl
}) => {
    const togglePositive = useCallback(
        () => dispatch(toggleIsPositive(transactionId, true)),
        [dispatch, transactionId]
    );

    const toggleNegative = useCallback(
        () => dispatch(toggleIsPositive(transactionId, false)),
        [dispatch, transactionId]
    );

    const Image = ({ className = '' }) => (
        <Figure
            captionText={state.label}
            captionColor={state.stateColor}
            className={className}
            imageUrl={imageUrl}
            title={title}
        />
    );

    const showForm = isNegative || isPositive;

    return (
        <div className={`d-flex ${className}`}>
            <div className="d-none d-md-block">
                <Image className="mr-4" />
            </div>
            <div className="flex-fill">
                <div className="d-flex px-2 px-md-0">
                    <div className="d-md-none">
                        <Image className="mr-2" />
                    </div>
                    <div className="flex-fill">
                        <Details
                            url={url}
                            title={title}
                            transactionDate={transactionDate}
                            memberUrl={memberUrl}
                            alias={alias}
                        />
                    </div>
                </div>
                <div className="d-block d-flex justify-content-center justify-content-md-start mt-2">
                    <Happy active={isPositive} onClick={togglePositive} />
                    <Sad
                        active={isNegative}
                        onClick={toggleNegative}
                        className="ml-3"
                    />
                </div>
                {showForm && (
                    <Form
                        comment={comment}
                        dispatch={dispatch}
                        errorMessageTranslationKeys={
                            errorMessageTranslationKeys
                        }
                        isItemNotReceived={isItemNotReceived}
                        transactionId={transactionId}
                        ratingSettings={ratingSettings}
                        ratings={ratings}
                        unpaidItemUrl={unpaidItemUrl}
                    />
                )}
            </div>
        </div>
    );
};

export const LeaveFeedbackItem = React.memo(_LeaveFeedbackItem);
